import { Link } from "react-router-dom";
import { BANNER_BOTTOM_PADDING } from "../components/ui/BugReporterBanner";

export function PrivacyPolicyPage() {
  return (
    <div className={`min-h-screen bg-gray-100 py-12 ${BANNER_BOTTOM_PADDING}`}>
      <div className="mx-auto max-w-3xl rounded-lg bg-white px-8 py-10 shadow-lg">
        <h1 className="mb-2 text-2xl font-bold text-gray-900">
          プライバシーポリシー
        </h1>
        <p className="mb-8 text-sm text-gray-500">最終更新日: 2026年4月10日</p>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            1. はじめに
          </h2>
          <p className="text-sm leading-relaxed text-gray-600">
            Sekitori（以下「本サービス」）は、株式会社メディオウルが運営するオフィス座席予約管理システムです。本プライバシーポリシーは、本サービスにおける個人情報の取り扱いについて説明します。
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            2. 収集する情報
          </h2>
          <p className="mb-2 text-sm leading-relaxed text-gray-600">
            本サービスでは、Google OAuth認証を通じて以下の情報を取得します。
          </p>
          <ul className="list-inside list-disc space-y-1 text-sm text-gray-600">
            <li>メールアドレス</li>
            <li>氏名（表示名）</li>
          </ul>
          <p className="mt-2 text-sm leading-relaxed text-gray-600">
            また、サービスの利用に伴い、以下の情報が記録されます。
          </p>
          <ul className="list-inside list-disc space-y-1 text-sm text-gray-600">
            <li>座席予約情報（予約日、座席番号）</li>
            <li>定期予約設定</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            3. 利用目的
          </h2>
          <p className="mb-2 text-sm leading-relaxed text-gray-600">
            収集した情報は、以下の目的のみに利用します。
          </p>
          <ul className="list-inside list-disc space-y-1 text-sm text-gray-600">
            <li>ユーザーの識別および認証</li>
            <li>座席予約機能の提供</li>
            <li>サービスの運用・改善</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            4. 第三者提供
          </h2>
          <p className="text-sm leading-relaxed text-gray-600">
            本サービスは、法令に基づく場合を除き、ユーザーの個人情報を第三者に提供することはありません。
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            5. データの保管
          </h2>
          <p className="text-sm leading-relaxed text-gray-600">
            ユーザーの情報は、Amazon Web
            Services（AWS）の東京リージョン（ap-northeast-1）に保管されます。適切なアクセス制御およびセキュリティ対策を講じています。
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            6. データの削除
          </h2>
          <p className="text-sm leading-relaxed text-gray-600">
            ユーザーは、管理者に依頼することでアカウントおよび関連データの削除を求めることができます。
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            7. ポリシーの変更
          </h2>
          <p className="text-sm leading-relaxed text-gray-600">
            本ポリシーは、必要に応じて変更される場合があります。重要な変更がある場合は、本サービス上で通知します。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="mb-2 text-lg font-semibold text-gray-800">
            8. お問い合わせ
          </h2>
          <p className="text-sm leading-relaxed text-gray-600">
            本ポリシーに関するお問い合わせは、サービス管理者までご連絡ください。
          </p>
        </section>

        <div className="border-t pt-4 text-center">
          <Link
            to="/auth/login"
            className="text-sm text-primary-600 hover:text-primary-500"
          >
            ログインページに戻る
          </Link>
        </div>
      </div>
    </div>
  );
}
